import React, { useState } from "react";
import { PlayFill } from "../../assets/SvgIcons";

const PlayVideoCard = ({
  videoUrl,
  thumbnailUrl,
  description,
  playTime,
  videoCardClassName,
}) => {
  const [selectedVideoId, setSelectedVideoId] = useState(null);

  const handleOpenVideo = () => {
    const videoId = videoUrl.split("v=")[1];
    setSelectedVideoId(videoId);
  };

  const handleCloseModal = () => {
    setSelectedVideoId(null);
  };

  return (
    <div className="my-6 mx-auto w-full">
      <div
        className={`relative lg:w-3/4 md:w-3/4 sm:w-full mx-auto ${videoCardClassName}`}
      >
        <div
          className="relative rounded-lg overflow-hidden"
          style={{ height: "0", paddingBottom: "56.25%" }}
        >
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url(${thumbnailUrl})`,
            }}
          >
            <button
              className="absolute inset-0 flex justify-center items-center"
              aria-label="Play video"
              onClick={handleOpenVideo}
            >
              <span className="text-white text-lg font-semibold">
                {PlayFill}
              </span>
            </button>
            <div className="absolute bottom-2 left-2 bg-gray-900 bg-opacity-75 px-2 py-1 rounded text-sm text-white">
              {playTime}
            </div>
          </div>
        </div>
        {description && (
          <span className="text-muted text-left mt-4 block">{description}</span>
        )}
      </div>

      {/* Modal for video playback */}
      {selectedVideoId && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50"
          onClick={handleCloseModal}
        >
          <div className="relative w-full max-w-3xl bg-black rounded-lg overflow-hidden">
            <button
              className="absolute top-2 right-2 text-white text-2xl"
              onClick={handleCloseModal}
            >
              &times;
            </button>
            <div className="relative w-full pt-[56.25%]">
              <iframe
                className="absolute top-0 left-0 w-full h-full"
                src={`https://www.youtube.com/embed/${selectedVideoId}`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PlayVideoCard;
